import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";

export default function StudentLessonsTab() {
  const parentContext = useOutletContext();

  return (
    <section className="sp-content">
      <div className="sl-window" aria-label="Lesson window">
        <Outlet context={parentContext} />
      </div>
    </section>
  );
}
